import Nav from "./Nav";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="App bg-background text-foreground min-h-screen flex flex-col" data-testid="app-layout">
      <Nav />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
